import styled from "styled-components";
import StockExceedInfo from "../../../assets/images/alertCircle.png";

const InfoNoteStyle = styled.div`
    .info-note,
    .info-note * {
        box-sizing: border-box;
    }
    .info-note {
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 10px 16px 10px 16px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-bottom: 16px;
    }
    .frame-29614 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .alert-circle {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .h-yer-paleet-could-not-fulfill-your-order-we-are-suggesting-another-store-below-you-can-also-cancel-the-item-for-a-full-refund {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
`;

const InfoNote = ({ setLocationInfo }) => {
    return (
        <InfoNoteStyle>
            <div className="info-note">
                <div className="frame-29614">
                    <img className="alert-circle" src={StockExceedInfo} alt="" />
                    <div className="h-yer-paleet-could-not-fulfill-your-order-we-are-suggesting-another-store-below-you-can-also-cancel-the-item-for-a-full-refund">
                        For your info: You are using multiple delivery locations for different items in your checkout.
                    </div>
                </div>
                <i
                    className="fa-light cursor-pointer"
                    onClick={() => {
                        setLocationInfo(true);
                    }}>
                    X
                </i>
            </div>
        </InfoNoteStyle>
    );
};

export default InfoNote;
